import { render } from "./ConfigurationRestorePointDeleteModal.vue?vue&type=template&id=18fcd66a"
import script from "./ConfigurationRestorePointDeleteModal.vue?vue&type=script&lang=js"
export * from "./ConfigurationRestorePointDeleteModal.vue?vue&type=script&lang=js"

import "./ConfigurationRestorePointDeleteModal.vue?vue&type=style&index=0&id=18fcd66a&lang=css"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
